module.exports = __webpack_public_path__ + "img/hxbank.2bd6feb7.png";